import "bootstrap-icons/font/bootstrap-icons.css";
import { Table } from "antd";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import {
  loadAllDesignation,
} from "../../redux/rtk/features/designation/designationSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { EditOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";

function CustomTable({ list, loading, onEdit }) {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Name",
      dataIndex: "DesignationName",
      key: "DesignationName",
    },
    {
      id: 3,
      title: "Action",
      dataIndex: "id",
      key: "action",
      render: (id, record) => (
        <Space>
          {/* <ViewBtn path={`/admin/designation/${id}`} /> */}
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  return (
    <div className="ant-card p-4 rounded designation-table-container">
      <div className="text-center my-2 flex justify-between">
        <h5 className="text-xl">Designation List</h5>
        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="designation"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      {list && (
        <div style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      <Table
        scroll={{ x: true, y: "100%" }}
        loading={loading}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
      />
    </div>
  );
}

const GetAllDesignation = ({ form, setIsEditMode, setCurrentDesignationId }) => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.designations);

  useEffect(() => {
    dispatch(loadAllDesignation());
  }, [dispatch]);

  const handleEdit = (record) => {
    // console.log("Editing record:", record); // Debug: Log the record to verify its structure
    setIsEditMode(true);
    const designationId = record.DesignationId; // Use DesignationId instead of id
    // console.log("Setting currentDesignationId to:", designationId); // Debug: Log the ID being set
    setCurrentDesignationId(designationId);

    // Try both DesignationName and name fields to find the correct one
    const designationName = record.DesignationName || record.name;
    // console.log("Designation Name to set:", designationName); // Debug: Log the value being set

    form.setFieldsValue({
      name: designationName,
    });

    // Debug: Log the form values after setting
    // console.log("Form values after setFieldsValue:", form.getFieldsValue());
  };

  return (
        <CustomTable list={list} loading={loading} onEdit={handleEdit} />
  );
};

export default GetAllDesignation;